<app-navbar-style-two></app-navbar-style-two>

<div class="recipe-details-page" *ngIf="recipe">

    <!-- === TOP BANNER === -->
    <div class="recipe-banner"
         [style.--bg-desktop]="getBgDesktop()"
         [style.--bg-mobile]="getBgMobile()">
        <div class="left-block">
            <h2>{{ recipe.title }}</h2>
            <h4>{{ recipe.subtitle }}</h4>
        </div>

        <div class="right-img"></div>

        <div class="brand-logos" *ngIf="recipe?.brand?.length">
            <img *ngFor="let brand of recipe.brand"
                 [src]="getImg(brand.image)"
                 [alt]="brand.name"
                 loading="lazy" />
        </div>
    </div>


    <!-- === CATEGORY BAR === -->
    <div class="detail-info-bar container">
        <div><strong>Category:</strong> {{ recipe?.rcategory?.name }}</div>
        <div><strong>Cooking Skill:</strong> {{ recipe?.cskill?.name }}</div>
        <div><strong>Preparation time:</strong> {{ recipe?.tpreparation }}</div>
        <div><strong>Cuisine:</strong> {{ recipe?.cuisine?.name }}</div>
    </div>


    <!-- === INGREDIENTS + METHOD === -->
    <div class="container-fluid ingredients-preparation-section">

        <div class="row">

            <!-- Ingredients -->
            <div class="col-md-6 ingredients-box">
                <h3 class="section-title">
                    <img src="assets/img/icons/ingri.svg" alt="Ingredients" width="20"/> Ingredients
                </h3>

                <ul>
                    <li *ngFor="let item of ingredientsList">
                        <span class="dot"></span> {{ item }}
                    </li>
                </ul>
            </div>

            <!-- Preparation -->
            <div class="col-md-6 preparation-box">
                <h3 class="section-title">
                    <img src="assets/img/icons/pre.svg" alt="Preparation" width="20" /> Method Of Preparations
                </h3>

                <ol>
                    <li *ngFor="let step of preparationSteps">
                        {{ step }}
                    </li>
                </ol>
            </div>

        </div>

    </div>

</div>
<section class="download-section">
    <div class="left">
      <h3>Download Brochure</h3>
      <p>Get detailed insights about our products and services</p>
    </div>
    <button class="primary-btn">Download Now</button>
  </section>
<app-footer-style-one></app-footer-style-one>
